import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';
                                        
export const useAllHeaters = (): Queries.allHeatersNodeFragmentFragment[] => {    
    const queryResult = useStaticQuery<Queries.allHeatersQuery>(graphql`
        query allHeaters {
            allHeaters: allProductsJson(
                filter: {
                    category: { regex: "^/Drolet/Heaters/" }
                    status: { eq: "actif" }
                }
            ) {
                nodes {
                    ...allHeatersNodeFragment
                }
            }
        }
    `);

    const staticHeaters = useMemo(() => queryResult.allHeaters.nodes.slice(), [queryResult]);
  

    return staticHeaters;
};
